// astro vue will render empty page if import vue from 'vue'
// @ts-ignore
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import hybridPage from '@/lib/hybridPage'
import { GaGeneralPageName } from '@/assets/ts/customEvent'
import { setCurrentGaPageName } from '@/lib/utils'
import MercariBrands from '@/pages/mercari-brands/components/_MercariBrands.vue'

hybridPage()

createApp({
	name: 'Mercari Brands Page',
	components: {
		MercariBrands,
	},
	setup() {
		setCurrentGaPageName(GaGeneralPageName.MercariBrands)

		const { mercariBrandsPageContent } = window.pageContent

		return {
			mercariBrandsPageContent,
		}
	},
}).mount('#bsMain')
